.summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}

.summaryExpanded {
  border-bottom: none;
}

.summaryInfo {
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.summaryText {
  display: flex;
  justify-content: flex-end;
}

.details {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto auto;
  gap: 1rem;
  align-items: start;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
}

.hidden {
  display: none;
}
